const mediaData = [
  {
    title: '独家揭秘：某顶流爱豆私生活混乱，多位知情人同时发声',
    duration: '15:32',
    views: '126万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20video%20thumbnail%20with%20warm%20dramatic%20lighting%2C%20abstract%20mysterious%20atmosphere%2C%20deep%20shadows%20and%20amber%20highlights%2C%20luxurious%20film%20grain%20texture%2C%20professional%20cinematography%20style%2C%20no%20text%2C%20no%20faces&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    title: '深度调查：娱乐公司内部权力斗争全记录',
    duration: '22:08',
    views: '98万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20corporate%20drama%20atmosphere%20with%20dark%20office%20interior%2C%20warm%20candlelight%20style%20glow%2C%20deep%20crimson%20and%20shadow%20tones%2C%20cinematic%20noir%20aesthetic%2C%20luxurious%20texture%2C%20professional%20film%20look%2C%20no%20text%2C%20no%20faces&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    title: '知情者专访：大热综艺剧本造假幕后真相',
    duration: '18:45',
    views: '87万',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20behind%20scenes%20dramatic%20lighting%20with%20warm%20amber%20spotlights%2C%20dark%20mysterious%20shadows%2C%20professional%20broadcast%20equipment%20silhouette%2C%20cinematic%20atmosphere%2C%20no%20text%2C%20no%20faces&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
  {
    title: '实拍记录：某网红翻车现场全程高能',
    duration: '09:17',
    views: '73万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20chaos%20scene%20with%20warm%20red%20and%20amber%20lighting%2C%20dynamic%20motion%20blur%20effect%2C%20cinematic%20documentary%20style%2C%20intense%20atmosphere%2C%20professional%20film%20grain%2C%20no%20text%2C%20no%20faces&width=640&height=360&seq=media-card-04&orientation=landscape',
  },
  {
    title: '圈内人爆料：影视圈潜规则大起底',
    duration: '31:22',
    views: '65万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20backstage%20film%20set%20ambiance%20with%20warm%20glowing%20lights%2C%20deep%20shadows%2C%20luxurious%20cinematic%20noir%20style%2C%20professional%20movie%20production%20atmosphere%2C%20no%20text%2C%20no%20faces&width=640&height=360&seq=media-card-05&orientation=landscape',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">精彩视频</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">热门爆料视频精选，画面直击事件现场</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaData.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group cursor-pointer"
            >
              <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-background-200 mb-3">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all">
                    <i className="ri-play-fill text-xl md:text-2xl"></i>
                  </div>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-1">{item.views} 次播放</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}